
// src/api/realtimeApi.js

import httpClient from '../utils/httpClient';

/**
 * Mint an ephemeral OpenAI session via your backend.
 * @returns {Promise<Object>} The session response, or throws error object from backend.
 */
export async function mintRealtimeSession(input = {}) {
  try {
    const { data } = await httpClient.post('/api/realtime/session', {
      trainingPlanId: input.trainingPlanId ?? null,
    });
    return data;
  } catch (err) {
    // Axios puts backend errors in err.response.data
    if (err.response && err.response.data) {
      // Re-throw backend error for frontend to handle
      throw err.response.data;
    }
    // Unknown error (network, etc.)
    throw { error: err.message || 'Unknown error minting session' };
  }
}

export async function getRealtimeEntitlements() {
  const { data } = await httpClient.get('/api/realtime/entitlements');
  return data?.entitlements || null;
}

export async function consumeRealtimeUsage({ elapsedSeconds, minutes, meetingId, trainingPlanId }) {
  const payload = {
    elapsedSeconds: elapsedSeconds ?? null,
    minutes: minutes ?? null,
    meetingId: meetingId ?? null,
    trainingPlanId: trainingPlanId ?? null,
  };
  const { data } = await httpClient.post('/api/realtime/usage/consume', payload);
  return data;
}
